var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Picker as ReactNativePicker } from "@react-native-picker/picker";
import React from "react";
import { Platform } from "react-native";
import { rentioThemeNative } from "../../../../../components/theme/theme.rentio";
import * as S from "./Picker.styles";
var Picker = /** @class */ (function (_super) {
    __extends(Picker, _super);
    function Picker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // Render
    Picker.prototype.render = function () {
        var _a = this.props, title = _a.title, items = _a.items, selectedValue = _a.selectedValue, onChangeValue = _a.onChangeValue;
        return (_jsxs(S.Wrap
        // Prevent the native <select> click from propagating through the modal
        // overlay to tab navigation links positioned behind it.
        // @ts-ignore – web-only: View supports onClick in React Native Web but TS types omit it
        , { 
            // Prevent the native <select> click from propagating through the modal
            // overlay to tab navigation links positioned behind it.
            // @ts-ignore – web-only: View supports onClick in React Native Web but TS types omit it
            onClick: function (e) { return e.stopPropagation(); }, children: [_jsxs(S.PickerStyled, { isPlaceholder: selectedValue === "" || selectedValue === undefined, selectedValue: selectedValue, onValueChange: function (value) {
                        if (value === "") {
                            onChangeValue(undefined);
                            return;
                        }
                        if (value) {
                            onChangeValue(value);
                        }
                    }, children: [title && Platform.OS === "web" && (_jsx(ReactNativePicker.Item, { value: "", label: title, color: rentioThemeNative.colors.neutral1 })), items.map(function (item) { return (_jsx(ReactNativePicker.Item, __assign({}, item, { color: rentioThemeNative.colors.neutral1 }), item.value)); })] }), _jsx(S.DropdownIcon, {})] }));
    };
    return Picker;
}(React.PureComponent));
// eslint-disable-next-line import/no-default-export
export default Picker;
